// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardAttendanceController = function ($scope, AttendanceAll, Attendance) {
    $scope.stats = {
        data: [],
        charts: {
            daily: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d) + 'h';
                    };
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('.2f')(d);
                    };
                }
            },
            weekly: {
                days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return $scope.stats.charts.weekly.days[Math.floor(d / 24)] + ' ' + (d % 24) + 'h';
                    };
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    };
                }
            },
            overall: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.time.format('%b %e, %H')(new Date(d * 60 * 60 * 1000)) + 'h';
                    };
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    };
                }
            },
            byEntity: {
                xAxisTickFormatFunction: function () {
                    return function (d) {
                        return d;
                    };
                },
                yAxisTickFormatFunction: function () {
                    return function (d) {
                        return d3.format('d')(d);
                    };
                }
            }
        }
    };

    var loadSettings = function () {
        var settings = localStorage.getItem('attendance_settings');

        if (settings) {
            try {
                return JSON.parse(settings);
            } catch (e) {
                console.log(e);
            }
        }

        return {
            dailyPeriod: 28,
            weeklyPeriod: 4,
            byEntityPeriod: 28,
            overallPeriod: 90
        };
    };
    var saveSettings = function () { localStorage.setItem('attendance_settings', JSON.stringify($scope.settings)); };

    // load settings from storage if any
    $scope.settings = loadSettings();

    $scope.refreshByEntity = function () {
        saveSettings();

        var data = Attendance.query({ type: 'byEntity', periodInDays: $scope.settings.byEntityPeriod }, function () {
            //$scope.stats.byEntity = getByEntityChartData(data.valuesPrev, data.values);
            $scope.stats.byEntity = data.values;
        });
    };

    $scope.refreshDaily = function () {
        saveSettings();

        var data = Attendance.query({ type: 'daily', periodInDays: $scope.settings.dailyPeriod }, function () {
            $scope.stats.charts.daily.data = getPlainChartData(data.values, 0, 'Calls');
        });
    };

    $scope.refreshOverall = function () {
        saveSettings();

        var data = Attendance.query({ type: 'overall', periodInDays: $scope.settings.overallPeriod }, function () {
            $scope.stats.charts.overall.data = getPlainChartData(data.values, data.start, 'Calls');
        });
    };

    $scope.refreshWeekly = function () {
        saveSettings();

        var data = Attendance.query({ type: 'weekly', periodInWeeks: $scope.settings.weeklyPeriod }, function () {
            $scope.stats.charts.weekly.data = getPlainChartData(data.values, 0, 'Calls');
        });
    };

    var getPlainChartData = function (data, start, label) {
        var values = new Array(data.length);
        for (var i = 0; i < data.length; i++) {
            values[i] = [i + start, data[i]];
        }
        return [{ key: label, values: values }];
    };

    var getByEntityChartData = function (dataPrev, data) {
        var entitiesToValues = {};

        for (var i = 0; i < dataPrev.length; i++) {
            entitiesToValues[dataPrev[i].Item1] = [dataPrev[i].Item2, 0];
        }

        for (var i = 0; i < data.length; i++) {
            if (!(data[i].Item1 in entitiesToValues)) {
                entitiesToValues[data[i].Item1] = [0, data[i].Item2];
            } else {
                entitiesToValues[data[i].Item1][1] = data[i].Item2;
            }
        }

        var result = [];
        for (var entity in entitiesToValues) {
            var values = entitiesToValues[entity];
            result.push({ key: entity, values: [['Previous', values[0]], ['Current', values[1]]] });
        }

        return result;
    };

    var data = AttendanceAll.query($scope.settings, function () {
        $scope.stats.data = data;
        $scope.stats.charts.daily.data = getPlainChartData(data.Daily, 0, 'Calls');
        $scope.stats.charts.weekly.data = getPlainChartData(data.Weekly, 0, 'Calls');
        $scope.stats.charts.overall.data = getPlainChartData(data.Overall, data.OverallStart, 'Calls');
        $scope.stats.byEntity = data.ByEntity;
    });
};

DashboardAttendanceController.$inject = ['$scope', 'AttendanceAll', 'Attendance'];
